import { Box, Typography } from '@material-ui/core';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import {
  getOrderItemsStatuses,
  getOrderStatuses,
  Status
} from 'Services/Query/Order-Statuses';

interface OrderStatusProps {
  status: string;
  orderItem?: boolean;
}

const OrderStatus = React.memo(
  ({ status, orderItem }: OrderStatusProps) => {
    const { data: statuses } = useQuery({
      ...(orderItem ? getOrderItemsStatuses() : getOrderStatuses()),
      select: (data: Status[]) => data,
      staleTime: 10 * 60 * 1000,
      cacheTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false
    });

    const foundStatus = statuses?.find(
      statusValue => statusValue.value === status
    );

    return (
      <Box display="flex" alignItems="center">
        {foundStatus?.icon && (
          <img src={foundStatus.icon} alt={foundStatus.label} width={24} />
        )}
        <Typography style={{ marginLeft: '10px' }}>
          {foundStatus?.label || status || 'Unknown'}
        </Typography>
      </Box>
    );
  },
  (prevProps, nextProps) => prevProps.status === nextProps.status
);

export default OrderStatus;
